import React from 'react';

import "./WidgetPreview.css";

export default class WidgetPreview extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  insertProfileSurvey() {
    const {profileQuestion} = this.props;

    profileQuestion && window.PlatformSDK.insertProfileSurvey(
      document.getElementById("widget-preview-profile-question"), profileQuestion
    );
  }

  componentDidMount() {
    this.insertProfileSurvey();
  }

  componentDidUpdate() {
    this.insertProfileSurvey();
  }  

  renderGuessNumber(description) {
    return (
      <div>
        <label
          className="widget-preview-question-description"
          htmlFor={`widget-preview-question-input-${description}`}
        >
          {description}
        </label>
        <input
          type="number"
          min="0"
          step="1"
          className="widget-preview-question-input"
          id={`widget-preview-question-input-${description}`}
          name="guess_number"
        >
        </input>
      </div>
    );
  }

  renderFreeForm(description) {
    return (
      <div>
        <label
          className="widget-preview-question-description"
          htmlFor={`widget-preview-question-input-${description}`}
        >
          {description}
        </label>
        <input
          type="text"
          className="widget-preview-question-input"
          id={`widget-preview-question-input-${description}`}
          name="free_form"
        >
        </input>
      </div>
    );
  }

  renderMultipleChoice(description, options) {
    const checkboxes = options.map((option, index) => {
      return (
        option && (
          <div className="widget-preview-question-checkbox-container" key={index}>
            <input
              type="checkbox"
              className="widget-preview-question-checkbox"
              id={`widget-preview-question-checkbox-${index},${option}`}
              name="multiple_choice"
            >
            </input>
            <label
              className="widget-preview-question-label"
              htmlFor={`widget-preview-question-checkbox-${index},${option}`}
            >
              {option}
            </label>
          </div>
        )
      );
    });

    return (
      <div>
        <div className="widget-preview-question-description">{description}</div>
        {checkboxes}
      </div>
    );
  }

  renderQuestionContainer(questions, index) {
    const {type, description, options} = questions[index];

    const content = (
      type === "guess_number"
      ? this.renderGuessNumber(description)
      : type === "free_form"
      ? this.renderFreeForm(description)
      : type === "multiple_choice"
      ? this.renderMultipleChoice(description, options)
      : undefined
    );

    return content;
  }

  render() {
    const {questions, profileQuestion} = this.props;

    const question1 = this.renderQuestionContainer(questions, 0);
    const question2 = this.renderQuestionContainer(questions, 1);

    return (
        <div className="widget-preview d-flex flex-column">
          <div className="widget-preview-title">Just one more thing</div>

          {
            question1
            && <div className="widget-preview-question-container">
              {question1}
            </div>
          }

          {
            question2
            && <div className="widget-preview-question-container">
              {question2}
            </div>
          }

          {
            profileQuestion
            && <div className="widget-preview-question-container">
              <div id="widget-preview-profile-question"></div>
            </div>
          }
        </div>
    );
  }
};
